export default "__VITE_ASSET__BPFkQFUc__"